import React from 'react';

interface Props {
  tipoApontamento: string[];
}

export const TabelaResumoOrdens = () => {

      const tipoApontamento = ['APROVADO', 'ANALIS', 'REPROCESSO', 'REFUGO', 'DESCARTE'];

      
  return (
    <div className="card mb-2">
      <div className="card-header"><h2 className="card-title h6 mb-0">Resumo de Ordens</h2></div>
      <div className="card-body p-0" style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-sm mb-1">
            <thead>
              <tr>
                <th>Número</th><th>Ordem</th><th>Operação</th><th>Chv.Mod.Apont</th>
                <th>Próximo Cen.Trab</th><th>Dt.Içto</th><th>Sequência</th>
                <th>Lote</th><th>Material</th><th>Descrição</th><th>UM</th><th>Qtd</th><th>Tipo Apontamento</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(10)].map((_, index) => (
                <tr key={index}>
                  <td>{index + 1}</td><td>11136933</td><td>2900</td><td>MONTAGEM</td>
                  <td>14MONTAG</td><td>10/06/2025</td><td>000000</td>
                  <td>0625100026</td><td>700166927</td><td>024 LAND ROVER DEFENDER</td>
                  <td>PEÇ</td><td>1</td>
                  <td>
                    <select className="form-select form-select-sm">
                      {tipoApontamento.map((tipo) => (
                        <option key={tipo} value={tipo}>{tipo}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
